import accountElements from "@/common/const/elementsList/accountElements";
import { useModal } from "@/common/contexts/Modal.context";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { useTableContext } from "@/common/contexts/Table.context";
import { MainHeader, ResetFiltersButton, Tabs } from "@/components";
import { PlusIcon } from "@/components/icon";
import SearchBar from "@/components/MainHeader/SearchBar";
import CreateNewAIRXUserModal from "@/components/Modals/CreateNewAIRXUser.modal";
import CreateNewCompanyModal from "@/components/Modals/CreateNewCompany.modal";
import CustomTypography from "@/components/Typography/CustomTypography";
import { Button } from "antd";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

function CreateNewCompanyBtn({
  display,
  func,
}: {
  display: boolean;
  func: () => void;
}) {
  return display ? (
    <>
      <Button className="h-10" type="primary" onClick={func}>
        <PlusIcon />
        <CustomTypography
          as="span"
          family={"inter"}
          weight={"semibold"}
          case={"capitalize"}
          color={"white"}
        >
          New Company
        </CustomTypography>
      </Button>
    </>
  ) : (
    <></>
  );
}
function CreateNewAIRXUserBtn({
  display,
  func,
}: {
  display: boolean;
  func: () => void;
}) {
  return display ? (
    <>
      <Button className="h-10" type="primary" onClick={func}>
        <PlusIcon />
        <CustomTypography
          as="span"
          family={"inter"}
          weight={"semibold"}
          case={"capitalize"}
          color={"white"}
        >
          New User
        </CustomTypography>
      </Button>
    </>
  ) : (
    <></>
  );
}

export default function AccountsLayouts() {
  const location = useLocation().pathname;
  const { resetFilters } = useTableContext();
  const { isHavePermission } = usePermissions();
  const { openModal } = useModal();
  const createNewUser = () => {
    openModal(<CreateNewCompanyModal />);
  };
  const createNewAirxUser = () => {
    openModal(<CreateNewAIRXUserModal />);
  };
  useEffect(() => {
    resetFilters();
    return () => resetFilters();
  }, []);
  return (
    <>
      <MainHeader>
        <SearchBar />
      </MainHeader>
      <div>
        <div className="flex justify-between  items-center pr-5">
          <div className="items-center flex px-5 pt-6  gap-2.5 -ml-8">
            <Tabs tabs={accountElements} />
            <ResetFiltersButton />
          </div>

          {(location.includes("customers") || location.includes("vendors")) && (
            <CreateNewCompanyBtn
              display={isHavePermission("company_create")}
              func={createNewUser}
            />
          )}
          {location.includes("airx-users") && (
            <CreateNewAIRXUserBtn
              display={isHavePermission("user_create")}
              func={createNewAirxUser}
            />
          )}
        </div>
        <Outlet />
      </div>
    </>
  );
}
